<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    $h: 188px;
    .remote {
        height: $h;

        video + video {
            position: absolute;
            right: 0;
            top: 0;
            width: 25%;
            height: $h/2;
        }
    }

    .local {
        height: $h;

        video + video {
            position: absolute;
            right: 0;
            top: 0;
            width: 25%;
            height: $h/2;
        }
    }

    video {
        width: 100%;
        height: $h;
        background-image: url("../../assets/video_bg.png");
    }

    .btns {
        background-color: rgba(0, 0, 0, 0.5);
        height: 35px;
    }

    img {
        @include w_h(20px);
    }
</style>
<template>
    <div class="flex column">
        <div class="remote relative flex0">
            <video ref="remoteVideo" autoplay :poster="require(('../../assets/video_bg.png'))"></video>
            <video ref="remoteVideo2" autoplay :poster="require(('../../assets/video_bg.png'))"></video>
            <audio ref="remoteAudio" autoplay></audio>
            <div class="absolute l0 r0 b0 pl10 pr10 btns flex aic">
                <span class="fs15 color_fff flex1">患者视频</span>
                <i class="flex0 color_fff iconfont icon-iconzuidahua pointer" @click="screenAll('2')"></i>
            </div>
        </div>
        <div class="local relative mt15 flex0" ref="local">
            <video muted autoplay :poster="require(('../../assets/video_bg.png'))"></video>
            <video muted autoplay :poster="require(('../../assets/video_bg.png'))"></video>
            <div class="absolute l0 r0 b0 pl10 pr10 btns flex aic">
                <span class="fs15 color_fff flex0">己方视频</span>
                <div class="video-btns flex1 flex aic jcc">
                    <img :src="btn.icon" :key="index" class="pointer" :class="{ml10:index>0}" @click="handler(btn.name)"
                         v-for="(btn,index) in btns" alt="">
                </div>
                <i class="flex0 color_fff iconfont icon-iconzuidahua pointer" @click="screenAll('1')"></i>
            </div>
        </div>
        <!--<message-box></message-box>-->
        <dis_message_box ref="msg"></dis_message_box>
        <video-tool-bar @handler="handlerBar" :share="false"></video-tool-bar>
        <send-msg-box-simple @send="send" ref="sendMsgBox"></send-msg-box-simple>
        <dis_msg_load ref="ImgLoad" v-show="false" @succ="succ"></dis_msg_load>
    </div>
</template>

<script>
  import {tee3mixin} from "../../lib/video/tee3mixin";
  import {isEmpty} from "../../lib/utils";
  import SendMsgBoxSimple from "../common/send-msg-box-simple";
  import dis_message_box from "../../components/dis/dis-message-box"
  import {disService} from "../../lib/service/dis"
  import VideoToolBar from "../../components/common/video-tool-bar"
  import dis_msg_load from "../../components/dis/dis-msg-load"
  import {YCMZ_CACHE_KEY} from "../../lib/config";

  const btns = [
    {name: '平铺', icon: require('../../assets/icon/online/pingpu.png')},
    {name: '静音', icon: require('../../assets/icon/online/jingyin.png')},
    {name: '关闭视频', icon: require('../../assets/icon/online/guanbishipin.png')},
    {name: '参会人员', icon: require('../../assets/icon/online/canhuirenyuan.png')},
    {name: '挂断', icon: require('../../assets/icon/online/guaduan.png')}
  ]


  export default {
    name: "dis-online-videos",
    components: {SendMsgBoxSimple, dis_message_box, VideoToolBar, dis_msg_load},
    props: {
      info: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    mixins: [tee3mixin],
    data() {
      return {
        removeVideos: [],
        userId: "",
        timer: null,
        btns
      }
    },
    created() {
      //屏幕共享回调事件
      bus.$on('onSubscribleScreenResult', this.updateVideo);
      bus.$on('onSubscribleCameraResult', this.addCameraResult);
      bus.$on('unScreenResult', this.findUserVideo);
    },
    beforeDestroy() {
      bus.$off('onSubscribleScreenResult', this.updateVideo);
      bus.$off('onSubscribleCameraResult', this.addCameraResult);
      bus.$off('unScreenResult', this.findUserVideo);
    },
    watch: {
      info: {
        handler: function (newVal) {
          this.getMsg();
        },
        deep: true
      }
    },
    methods: {
      findUserVideo() {
        const obj = this.findVideo(this.userId, 'video');
        this.$refs.remoteVideo.srcObject = obj.stream;
      },
      addCameraResult(stream, userId, userName, cameraId) {
        this.userId = userId;
        this.updateOrAddVideo({stream, userId, userName, cameraId, type: 'video'});
      },
      updateVideo(stream, userId, userName, screenId) {
        Log('remoteVideo', screenId, this.$refs.remoteVideo);
        this.$refs.remoteVideo.srcObject = stream;
      },
      screenAll(ty) {
        let el = ty == '1' ? this.$refs.local : this.$refs.remoteVideo;
        if (el.requestFullscreen) {
          el.requestFullscreen();
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen();
        } else if (el.webkitRequestFullScreen) {
          el.webkitRequestFullScreen();
        }
      },
      getMsg() {
        this.$refs.msg.getMsg(this.info.id);
        this.clearTimer();
        this.timer = setTimeout(this.getMsg, 5000);
      },
      clearTimer() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      },
      //发送图片成功的回调
      async succ() {
        await this.getMsg();
      },
      //发送消息
      async send(content) {
        if (this.info.finsh) {
          this.$message.error('会诊已经结束，无法发送消息。');
          return
        }
        if (await disService.reply({
          outpatientId: this.info.id,
          msgContent: content
        })) {
          await this.getMsg();
          this.$refs.sendMsgBox.clear();
        }
      },
      handler(type) {
        const map = this.handlerMap();
        const ac = [...map].find(([key]) => key === type);
        if (isEmpty(ac)) {
          this.$message.error('未定义 ' + type + " 操作");
        } else {
          ac[1]();
        }
      },//tee3CloseMicrophone
      async handlerBar(type) {
        if (this.info.finsh) {
          this.$message.error('会诊已经结束，无法使用相关功能。');
          return
        }
        if (type == '邀请讨论') {
          this.$message.error('功能暂未开放');
          // this.$refs.shareRoomDialog.show()
        }

        if (type == '图片') {
          this.$refs.ImgLoad.start(this.info.id);
        }

        if (type == '文件传输') {
          this.$refs.ImgLoad.startFile(this.info.id);
        }

        if (type == '桌面分享') {
          const that = this;
          await this.openScreenAndPub(this.$refs['local']);
          setTimeout(() => {
            that.checkScreenOutSelfUser(this.$refs['local']);
          }, 5000);
        }

        if (type == '白板') {
          this.$emit('openBank');
        }
      },
      handlerMap() {
        return new Map([
          ['平铺', () => {
            //if (this.getRoom()) return this.$message.error('还未进入房间');
            this.$cache.set(YCMZ_CACHE_KEY, this.info);
            this.$router.push({
              path: "/other/ycmz/fullscreen",
              query: {
                id: this.info.id || 5041,
                from: "accept"
              }
            })
          }],
          ['挂断', () => {
            this.$confirm('是否退出房间？', '提示').then(() => {
              this.leaveRoom();
            })
          }],
          ['静音', () => {
            if (this.getRoom()) return this.$message.error('还未进入房间');
            let status = this.gettee3microphoneStatus(); // 2 没有静音 1 已静音
            this.$confirm(status == '2' ? '是否关闭麦克风？' : '是否打开麦克风？', '提示').then(() => {
              if (status == '2') {
                this.closeMicro();
              } else {
                this.openMicro();
              }
            })
          }], ['关闭视频', () => {
            if (this.getRoom()) return this.$message.error('还未进入房间');
            let status = this.gettee3videoStatus(); // 2 没有关闭 1 已关闭
            if (status == "") return
            this.$confirm([2, 6].indexOf(status) != -1 ? '是否关闭摄像头？' : '是否打开摄像头？', '提示').then(() => {
              if (status == '2' || status == '6') {
                this.tee3CloseVideo();
              } else {
                this.tee3OpenVideo(this.$refs['local']);
              }
            })
          }]
        ])
      },
      enterRoom() {
        this.tee3enterRoom();
      },
      leaveRoom() {
        this.tee3leaveRoom();
      },
      //打开麦克风
      openMicro() {
        this.tee3OpenMicrophone();
      },
      //关闭麦克风
      closeMicro() {
        this.tee3CloseMicrophone();
      },
      handlerRemoteMedia({type, stream, userId, cameraId}) {
        Log('media', {type, stream, userId, cameraId})
        if (type === 'video') {
          Log('remoteVideo', this.$refs.remoteVideo);
          if (this.$refs.remoteVideo && this.$refs.remoteVideo.srcObject)
            this.$refs.remoteVideo2.srcObject = stream;
          else this.$refs.remoteVideo.srcObject = stream;
        }
        if (type === 'audio') {
          Log('remoteAudio', this.$refs.remoteAudio);
          this.$refs.remoteAudio.srcObject = stream;
        }
      }
    }
  }
</script>
